<div class="col-sm-12">

    <h3 class="text-light-blue">
        Filtro realizado de <b>{{ this.periodoInicial | date:'dd/MM/yyyy' }}</b> até <b>{{ this.periodoFinal
            | date:'dd/MM/yyyy' }}</b>

        <button class="btn btn-sm btn-danger pull-right"><i class="fa fa-fw fa-file-pdf-o"></i> Gerar relatório</button>
    </h3>

    <hr>

    <h3>Listas de despesas comuns</h3>
    <hr>

    <div class="col-sm-12">
        <table class="table table-bordered">
            <tbody>
                <tr>
                    <th>Meta/Etapa</th>
                    <th>Despesa</th>
                    <th>Fornecedor</th>
                    <th>Valor</th>
                    <th>NF</th>
                    <th>Data fato</th>
                </tr>
                <tr *ngFor="let item of listaDespesasComuns; let i = index">
                    <td>
                        <ul class="tree">
                            <li>Meta:
                                {{item.despesaId?.detalhamentoFisicoHasDespesa[0]?.detalhamentoFinanceiroHasEtapaCronogramaFisico?.detalhamentoFinanceiro?.especificacao}}
                            </li>
                            <li>Etapa:
                                {{item.despesaId?.detalhamentoFisicoHasDespesa[0]?.detalhamentoFinanceiroHasEtapaCronogramaFisico?.etapaCronogramaFisico?.descricao}}
                            </li>
                        </ul>
                    </td>
                    <td>
                        <ul class="tree">
                            <ng-container *ngFor="let itemDetalhe of item.despesaId?.detalhamentoFisicoHasDespesa">
                                <li>{{itemDetalhe.detalhamentoFinanceiroHasEtapaCronogramaFisico.especificacao}}
                                </li>
                            </ng-container>
                        </ul>
                    </td>
                    <td>
                        <ul class="tree">
                            <li>CPF/CNPJ: {{item.despesaId?.cpfCnpjVencedor}}</li>
                            <li>Nome: {{item.despesaId?.nomeFavorecido}}</li>
                        </ul>
                    </td>
                    <td>{{item.despesaId?.valor | currency:'BRL':'symbol-narrow':'1.2-2'}}</td>
                    <td>
                        <span class="btn btn-xs btn-primary"
                            (click)="openViewPDF(item.despesaId?.hashFile)">{{item.despesaId?.nfAnexoVencedor}}</span>
                    </td>
                    <td>{{item.dataFatoMovimentacao | date: 'dd/MM/yyyy'}}</td>
                </tr>
            </tbody>
        </table>
    </div>

    <br>
    <br>

    <h3>Listas de despesas com pessoal</h3>
    <hr>

    <div class="col-sm-12">
        <table class="table table-bordered">
            <tbody>
                <tr>
                    <th>Descrição</th>
                    <th>Atribuição</th>
                    <th>Pessoa</th>
                    <th>Status</th>
                    <th>Valor</th>
                    <th>Recibo</th>
                    <th>Transferência</th>
                    <th>Data ocorrência</th>
                </tr>
                <tr *ngFor="let item of listaDespesasPessoal; let i = index">
                    <td>{{item.tipoDespesaReceita?.descricao}}</td>
                    <td>{{item.pagamentoPessoalId?.pessoalProjeto?.atribuicao}}</td>
                    <td>{{item.pagamentoPessoalId?.pessoalProjeto?.nome}}</td>
                    <td>{{item.pagamentoPessoalId?.pessoalProjeto?.statusPessoa}}</td>
                    <td>{{item.pagamentoPessoalId?.valor | currency:'BRL':'symbol-narrow':'1.2-2'}}</td>
                    <td>
                        <span class="btn btn-xs btn-primary"
                            (click)="openViewPDF(item.pagamentoPessoalId?.hashComprovanteRecibo)">{{item.pagamentoPessoalId?.comprovanteRecibo}}</span>
                    </td>
                    <td>
                        <span class="btn btn-xs btn-primary"
                            (click)="openViewPDF(item.pagamentoPessoalId?.hashComprovanteTransferencia)">{{item.pagamentoPessoalId?.comprovanteTransferencia}}</span>
                    </td>
                    <td>{{item.dataFatoMovimentacao | date: 'dd/MM/yyyy'}}</td>
                </tr>
            </tbody>
        </table>
    </div>

</div>

<p-dialog [style]="{width: '800px', 'min-height': '500px'}" header="Documento" [(visible)]="displayOpenModalView" showEffect="fade"
    [modal]="true">
    <div class="col-sm-12 text-center">
        <div class="embed-container" *ngIf="viewDownload">
            <div class="myIframe">
                <iframe [src]="urlDocumento | safe" frameborder='0'></iframe>
            </div>
        </div>
    </div>
</p-dialog>